/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */
import React from "react";
// You can delete this file if you're not using it
import "./src/styles/global.css";
import { ThemeProvider } from "./src/context/ThemeContext"
import { ToastContainer } from "react-toastify"

export const onRouteUpdate = ({ location }) => {
  if (typeof window !== "undefined") {
    const isAuthenticated = !!localStorage.getItem("token"); // O usa un contexto global
    const protectedRoutes = ["/dashboard", "/admin",];
    const isProtected = protectedRoutes.some(route => location.pathname.startsWith(route));
    if (!isAuthenticated && isProtected) {
      window.location.href = "/login";
    }
  }
};

export const onRenderBody = ({ setBodyAttributes }) => {
  setBodyAttributes({
    className: "gatsby dark:bg-gray-900",
  });
};



export const wrapRootElement = ({ element }) => {
  return (
    <ThemeProvider>
      <ToastContainer position="top-center" style={{ zIndex: 199999 }} />
      {element}
    </ThemeProvider>
  )
}